import { useState, useEffect, useCallback } from 'react';
import api from '@/lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Phone, Plus, Trash2, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

export default function NumeriUtiliSection() {
  const [numeri, setNumeri] = useState([]);
  const [salvataggio, setSalvataggio] = useState(false);
  const [caricato, setCaricato] = useState(false);

  const carica = useCallback(() => {
    api.get('/utility/numeri-utili').then(r => { setNumeri(r.data.numeri || []); setCaricato(true); }).catch(() => {});
  }, []);

  useEffect(() => { carica(); }, [carica]);

  const salva = async () => {
    setSalvataggio(true);
    try {
      await api.put('/utility/numeri-utili', { numeri: numeri.filter(n => (n.nome || '').trim()) });
      toast.success('Numeri utili aggiornati');
      carica();
    } catch (e) { toast.error(e.response?.data?.detail || 'Errore salvataggio'); }
    setSalvataggio(false);
  };

  if (!caricato) return null;

  return (
    <Card data-testid="numeri-utili-section">
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2">
          <Phone className="w-5 h-5 text-slate-600" />Numeri utili stampati sulla scheda emergenza
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <p className="text-xs text-slate-500">
          Questi numeri compaiono sulla scheda emergenza di ogni ospite, accanto al recapito del medico di base.
        </p>
        <div className="space-y-2">
          {numeri.map((n, i) => (
            <div key={i} className="flex items-center gap-2">
              <Input className="h-9 text-xs flex-1" placeholder="Nome" value={n.nome || ''}
                onChange={e => setNumeri(ns => ns.map((x, j) => j === i ? { ...x, nome: e.target.value } : x))}
                data-testid={`numero-nome-${i}`} />
              <Input className="h-9 text-xs w-40" placeholder="Telefono" value={n.telefono || ''}
                onChange={e => setNumeri(ns => ns.map((x, j) => j === i ? { ...x, telefono: e.target.value } : x))}
                data-testid={`numero-tel-${i}`} />
              <Input className="h-9 text-xs flex-1" placeholder="Note / indirizzo" value={n.note || ''}
                onChange={e => setNumeri(ns => ns.map((x, j) => j === i ? { ...x, note: e.target.value } : x))} />
              <Button variant="ghost" size="sm" className="h-8 w-8 p-0" onClick={() => setNumeri(ns => ns.filter((_, j) => j !== i))}>
                <Trash2 className="w-3.5 h-3.5 text-slate-400" />
              </Button>
            </div>
          ))}
        </div>
        <div className="flex gap-2">
          <Button variant="outline" size="sm" className="h-9 text-xs"
            onClick={() => setNumeri(ns => [...ns, { nome: '', telefono: '', note: '' }])} data-testid="aggiungi-numero">
            <Plus className="w-3.5 h-3.5 mr-1" />Aggiungi numero
          </Button>
          <Button size="sm" className="h-9 text-xs bg-brand hover:bg-brand-dark text-white" onClick={salva}
            disabled={salvataggio} data-testid="salva-numeri">
            {salvataggio ? <Loader2 className="w-3.5 h-3.5 mr-1 animate-spin" /> : null}Salva
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
